import memoize from 'memoizee'
import { areDatesEqual, isDateBefore, isDateAfter } from '@myap/ui-library/esm/date'

const _parseFloatable = value => {
  return typeof value === 'string' &&
    (/^\d+$/.test(value) || /^\d+$/.test(value.replace(/[,.%$]/g, '')))
    ? true
    : false
}

const _parseIfFloat = value => {
  return parseFloat(value.replace(/,/g, ''))
}

const _cleanDataType = value => {
  return _parseFloatable(value)
    ? _parseIfFloat(value)
    : typeof value === 'string'
    ? value.toLowerCase()
    : value
}

const _sortDataByKeyProps = (prop, emptyValuesFirst) => {
  return keyValues => {
    const a = _cleanDataType(keyValues[0][prop])
    const b = _cleanDataType(keyValues[1][prop])

    if (emptyValuesFirst) return !a ? -1 : !b ? 1 : a > b ? 1 : a < b ? -1 : 0

    return !a ? 1 : !b ? -1 : a > b ? 1 : a < b ? -1 : 0
  }
}

const _sortPositionOfData = (data, dirs, emptyValuesFirst) => {
  const props = data
  return (a, b) => {
    const keyArrAsc = [a, b]
    const keyArrDesc = [b, a]

    let i = 0,
      result = 0
    while (result === 0 && i < props.length) {
      const dir = dirs[i] || dirs[0]
      const keyValues = dir?.toLowerCase() === 'desc' ? keyArrDesc : keyArrAsc
      result = a.defaultToTop
        ? -1
        : b.defaultToTop
        ? -1
        : _sortDataByKeyProps(props[i], emptyValuesFirst)(keyValues)
      i++
    }
    return result
  }
}

const _sortDataByKey = (data, key, fn) => {
  const clone = Array.apply(null, data)
  return clone.sort((a, b) => {
    return fn(a[key], b[key])
  })
}

export const sortColumnByKey = (data, key, dir, emptyValuesFirst = false) => {
  const keys = Array.isArray(key) ? key : [key]
  const dirs = Array.isArray(dir) ? dir : [dir]
  const dirsLength = dirs.length
  let clone = Array.apply(null, data)
  // If dirs is shorter than keys (because someone specified multiple sort columns, but
  // didn't specify the sort order for the same number of columns), pad out the
  // dirs column with 'asc' sort direction.
  if (keys.length > dirsLength) {
    dirs.length = keys.length
    dirs.fill('asc', dirsLength)
  } else if (dirsLength > keys.length) {
    console.warn(
      'WARNING: More sort directions have been specified than the number of columns to sort on'
    )
  }
  clone.sort(_sortPositionOfData(keys, dirs, emptyValuesFirst))
  return clone
}

export const sortColumnByDate = memoize((data, key, dir) => {
  // const clone = Array.apply(null, data)
  // const keys = Array.isArray(key) ? key : [key]
  // const dirs = Array.isArray(dir) ? dir : [dir]
  // return clone.sort(_sortPositionOfData(keys, dirs))
  return _sortDataByKey(data, key, (a, b) => {
    if (!a) return 1
    if (!b) return -1
    if (areDatesEqual(a, b)) return 0
    if (dir === 'desc') return isDateBefore(a, b) ? 1 : -1
    else return isDateAfter(a, b) ? 1 : -1
  })
})

// Looks like memoize won't work when data is grouped because the top-level groups themselves aren't
// changing, so memoize doesn't see the data as unique
export const sortGroupedColumnByKey = (data, key, dir) => {
  const keys = Array.isArray(key) ? key : [key]
  const dirs = Array.isArray(dir) ? dir : [dir]
  let clone = {}
  Object.keys(data).forEach(key => {
    Object.assign(clone, { [key]: data[key].sort(_sortPositionOfData(keys, dirs)) })
  })
  return clone
}

// export const sortColumnByDate = memoize(( data, key, dir ) => _sortDataByKey(data, key, ((a, b) => {
//   return a && b ? dir == 'desc' ? moment(a).isBefore(b) : moment(a).isAfter(b) : null
// })))

// export const sortColumnByDate = ( data, key, dir ) => {
//   const sortDir = Array.isArray(dir) ? dir[0] : dir
//   return _sortDataByKey(data, key, ((a, b) => {
//     return moment(a).isSame(b) ? 0 : isDateBeforeOrAfter(a, b, sortDir) ? 1 : -1
//   }))
// }

export const checkGroupedDataForSameness = memoize((data, key, isGrouped = false) => {
  const keys = Array.isArray(key) ? key : [key]
  // Checks for sameness across all columns selected for sorting
  // output = keys.every(sortKey => {
  //   return Object.keys(data).every(dataKey => {
  //       return data[dataKey].every((d, i, arr) => {
  //         return (d[sortKey] !== undefined) && (d[sortKey] === arr[0][sortKey])
  //       })
  //     })
  //   }
  // )

  // Checks for sameness on primary sort column only
  const output = Object.keys(data).every(dataKey => {
    return data[dataKey].every((d, i, arr) => {
      return d[keys[0]] !== undefined && d[keys[0]] === arr[0][keys[0]]
    })
  })
  return output
})

export const checkForSameness = memoize((data, key, isGrouped = false) => {
  const keys = Array.isArray(key) ? key : [key]
  // Checks for sameness across all columns selected for sorting
  // output = keys.every(sortKey => data.every((d, i, arr) => {
  //   return (d[sortKey] !== undefined) && (d[sortKey] === arr[0][sortKey])
  // }))

  // Checks for sameness on primary sort column only
  const output = data.every((d, i, arr) => {
    return d[keys[0]] !== undefined && d[keys[0]] === arr[0][keys[0]]
  })
  return output
})

export const groupBy = memoize((data, key) => {
  return data.reduce((groups, item) => {
    const val = item[key]
    groups[val] = groups[val] || []
    groups[val].push(item)
    return groups
  }, {})
})
